module.exports = __webpack_public_path__ + "static/media/animal_07_big.b7ba3311.png";